import API_BASE, { withApiCredentials } from "../../api";
import { getActiveAwareAuthToken } from "../../auth/bootstrapTokens";

export async function getFishingOutlookBetaAccess({ signal } = {}) {
  const token = getActiveAwareAuthToken(
    typeof window !== "undefined" ? window : undefined
  );
  const response = await fetch(
    `${API_BASE}/fishing-intelligence/access`,
    withApiCredentials({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      signal,
    })
  );

  if (!response.ok) {
    throw new Error("Fishing Outlook access request failed");
  }

  const payload = await response.json();
  return { canAccess: payload?.canAccess === true };
}
